import {Component} from '@angular/core';
import {IonButton, IonCol, IonItem, IonList, IonRadio, IonRadioGroup, IonRow, NavParams, RadioGroupChangeEventDetail} from '@ionic/angular/standalone';

import {TranslateModule} from '@ngx-translate/core';
import {ResponsiveContainerComponent} from '../responsive-container/responsive-container.component';
import {AnimatedLogoComponent} from '../animated-logo/animated-logo.component';
import {AnimatedContainerComponent} from '../animated-container/animated-container.component';
import {SignatureCreatorComponent} from '../signature-creator/signature-creator.component';
import {ThemeService} from '../../services/theme.service';
import {Theme} from '../../interfaces/theme';
import {LoadingService} from '../../services/ionic/loading.service';
import {BrandingLayoutComponent} from '../branding-layout/branding-layout.component';
import {BrandingLayoutService} from '../../services/branding-layout.service';

@Component({
    selector: 'app-theme-selector',
    templateUrl: './theme-selector.component.html',
    styleUrls: ['./theme-selector.component.scss'],
  imports: [TranslateModule, BrandingLayoutComponent, IonRadio, IonItem, IonRadioGroup, IonList, IonCol, IonRow, IonButton]
})
export class ThemeSelectorComponent {

  public availableThemes: Theme[]

  public htmlIonModalElement: HTMLIonModalElement;

  public preferredThemeId: string;

  public currentThemeId: string;

  public constructor(private navParams: NavParams,
                     private themeService: ThemeService,
                     private loadingService: LoadingService,
                     private brandingLayoutService: BrandingLayoutService) {
    const data: { [p: string]: any } = this.navParams.data;

    if (data) {
      const modal: HTMLIonModalElement = data['modal'];

      if (modal) {
        this.htmlIonModalElement = modal;
      }
    }

    this.currentThemeId = themeService.preferredThemeId ?? null;
    this.availableThemes = themeService.getAvailableThemes();
    this.brandingLayoutService.backButton = this.cancel.bind(this);
    this.brandingLayoutService.hideHeaderButton = true;
    this.brandingLayoutService.hideFooter = true;
  }

  public async onThemeChange(event: any): Promise<void> {
    const radioGroupChangeEventDetail: RadioGroupChangeEventDetail = event?.detail;

    this.preferredThemeId = radioGroupChangeEventDetail?.value;
    const preferredTheme: Theme = this.themeService.getPreferredTheme(this.preferredThemeId);

    this.themeService.activateTheme(preferredTheme);
  }

  public async selectTheme(): Promise<void> {
    await this.loadingService.runWithLoading(async () => {
      await this.themeService.setPreferredThemeId(this.preferredThemeId);
    });

    await this.htmlIonModalElement.dismiss(undefined, 'select');
  }

  public async cancel(): Promise<void> {
    const preferredTheme: Theme = this.themeService.getPreferredTheme(this.currentThemeId);
    this.themeService.activateTheme(preferredTheme);
    await this.htmlIonModalElement.dismiss(undefined, 'back')
  }

}
